export const breakpoints = {
    sm: 0,
    md: 672,
    lg: 1056,
    xl: 1312,
    xxl: 1584,
};
export type Breakpoint = keyof typeof breakpoints;

export const getCurrentViewWidth = (): number => {
    return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
}

export const getAttributeNameForBreakpoint = (attributeNameBase: string, breakpoint: Breakpoint) => {
    const breakpointNames = Object.keys(breakpoints);
    if (breakpointNames.indexOf(breakpoint) === 0) {
        return attributeNameBase;
    } else {
        return `${attributeNameBase}-${breakpoint}`;
    }
}

export const getAttributeValueForBreakpoint = (element: HTMLElement, attributeNameBase: string, breakpoint: Breakpoint, cascadeDown = true, defaultValue: string | null = null): string | null => {
    const attributeName = getAttributeNameForBreakpoint(attributeNameBase, breakpoint);
    if (element.hasAttribute(attributeName)) {
        return element.getAttribute(attributeName);
    } else if (cascadeDown) {
        const breakpointNames = Object.keys(breakpoints);
        const breakpointLevel = breakpointNames.indexOf(breakpoint);
        if (breakpointLevel > 0) {
            return getAttributeValueForBreakpoint(element, attributeNameBase, breakpointNames[breakpointLevel - 1] as Breakpoint, cascadeDown, defaultValue);
        }
    }
    return defaultValue;
}

export const getCurrentBreakpoint = (): Breakpoint => {
    const breakpointNames = Object.keys(breakpoints);
    const currentWidth = getCurrentViewWidth();
    for (let breakpointIndex = breakpointNames.length - 1; breakpointIndex >= 0; breakpointIndex--) {
        if (currentWidth >= breakpoints[breakpointNames[breakpointIndex]]) {
            return breakpointNames[breakpointIndex] as Breakpoint;
        }
    }
    return breakpointNames[0] as Breakpoint;
}

export const getAttributeValueForCurrentBreakpoint = (element: HTMLElement, attributeNameBase: string, cascadeDown = true, defaultValue: string | null = null): string | null => {
    return getAttributeValueForBreakpoint(element, attributeNameBase, getCurrentBreakpoint(), cascadeDown, defaultValue);
}
